import React, { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

import { kcGateway } from '../../utils/keycloak';

export const NEXT_URL_STORAGE_KEY = 'nextUrl';

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const hasHandled = useRef(false);

  useEffect(() => {
    // Wait until react-oidc-context finishes processing the callback
    if (auth.isLoading || hasHandled.current) {
      return;
    }

    hasHandled.current = true;

    const handlePostLogin = async () => {
      let shouldNavigate = true;

      // Check if this callback is from a logout and we should login again
      const shouldLoginAfterLogout = sessionStorage.getItem(
        'shouldLoginAfterLogout'
      );
      const shouldRegisterAfterLogout = sessionStorage.getItem(
        'shouldRegisterAfterLogout'
      );

      try {
        if (shouldLoginAfterLogout === 'true') {
          sessionStorage.removeItem('shouldLoginAfterLogout');
          await kcGateway.login();
          shouldNavigate = false;

          return;
        }

        if (shouldRegisterAfterLogout === 'true') {
          sessionStorage.removeItem('shouldRegisterAfterLogout');
          await kcGateway.signUp();
          shouldNavigate = false;

          return;
        }
      } catch (redirectError) {
        console.error('Failed to redirect after logout:', redirectError);
        // Clean up flags and continue to normal navigation
        sessionStorage.removeItem('shouldLoginAfterLogout');
        sessionStorage.removeItem('shouldRegisterAfterLogout');
      } finally {
        // Always ensure we navigate somewhere if no redirect happened
        if (shouldNavigate) {
          const redirectUrl =
            sessionStorage.getItem(NEXT_URL_STORAGE_KEY) || '/';

          navigate(redirectUrl);
        }
      }
    };

    handlePostLogin();
  }, [auth.isLoading, navigate]);

  return <div />;
};

export default AuthCallbackPage;
